<template>
  <div id="BrandSwitching">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3>公司品牌切换</h3>
        </div>  
      </el-card>  
      <el-card style="height:800px;"> 
        <span class="span11">公司</span>
        <el-select v-model="selectData"  placeholder="请选择"  @change="companySwitching" size="small">
          <el-option
            v-for="item in dataList"
            :key="item.cpyNO"
            :value="item.cpyNO"
            :label="item.companyName"
          >
          </el-option>
        </el-select>
      </el-card>
  </div>
</template>
<script>
export default {
    props:{
        dataList:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    data() {
       return{
           selectData:""
       }
    },
    methods:{
        companySwitching(val){
            this.$emit("companySwitching",val)
        }
    }
}
</script>
<style lang="scss" scoped>
.span11{
    margin-right:10px ;
}
</style>